import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { object } from "yup";
import { addGiftCardFormSchema, existingGiftCardFormSchema } from "./GiftCardApplyForm-types";
export const useGiftCardApplyForm = () => {
    const [isApplyGiftCardModalOpen, setIsApplyModalOpen] = useState(false);
    const showHideGiftCardForm = () => {
        clearErrorsAddGiftCard();
        clearErrorsExistingGiftCard();
        setIsApplyModalOpen((prev) => !prev);
    };
    // Methods for adding a new giftcard via textbox
    const methodsAddGiftCard = useForm({
        mode: "onSubmit",
        resolver: yupResolver(object(addGiftCardFormSchema)),
    });
    const { control: controlAddGiftCard, formState: formStateAddGiftCard, handleSubmit: handleSubmitAddGiftCard, clearErrors: clearErrorsAddGiftCard, } = methodsAddGiftCard;
    const { isSubmitting: addGiftCardIsSubmitting } = formStateAddGiftCard;
    // Methods for using an existing giftcard via radio buttons
    const methodsExistingGiftCard = useForm({
        mode: "onSubmit",
        resolver: yupResolver(object(existingGiftCardFormSchema)),
    });
    const { control: controlExistingGiftCard, formState: formStateExistingGiftCard, handleSubmit: handleSubmitExistingGiftCard, clearErrors: clearErrorsExistingGiftCard, } = methodsExistingGiftCard;
    const { isSubmitting: existingGiftCardIsSubmitting } = formStateExistingGiftCard;
    const giftCardModalProps = {
        isApplyGiftCardModalOpen,
        showHideGiftCardForm,
        addGiftCardProps: {
            control: controlAddGiftCard,
            formState: formStateAddGiftCard,
            handleSubmit: handleSubmitAddGiftCard,
            isSubmitting: addGiftCardIsSubmitting,
        },
        existingGiftCardProps: {
            control: controlExistingGiftCard,
            formState: formStateExistingGiftCard,
            handleSubmit: handleSubmitExistingGiftCard,
            isSubmitting: existingGiftCardIsSubmitting,
        },
    };
    return giftCardModalProps;
};
